export const HOUR_CHOICES: readonly number[] = Array.from({ length: 24 }, (_, h) => h);

export const DAY_OF_MONTH_CHOICES: readonly number[] = Array.from({ length: 31 }, (_, i) => i + 1);

export const WEEKDAY_CHOICES: readonly number[] = Array.from({ length: 7 }, (_, d) => d);

export function scheduleDayFor(kind: 'DAILY' | 'WEEKLY' | 'MONTHLY', current: number[]): number[] {
  if (kind === 'DAILY') return [];
  if (kind === 'WEEKLY') {
    const d = current.length === 1 && current[0] >= 0 && current[0] <= 6 ? current[0] : 1;
    return [d];
  }
  return current.filter((d) => d >= 1 && d <= 31);
}
